export const iconFontAwesomeHalloweenCloudMoon = (
	<i className="fa-solid fa-cloud-moon"></i>
);
